// extracted by mini-css-extract-plugin
module.exports = {"Spinnerborder":"Spinner_Spinnerborder__1-Aga","spinner-border":"Spinner_spinner-border__dXnTt","center":"Spinner_center__bGKWd"};